import { MdCheck } from 'react-icons/md';
import InputMask from 'react-input-mask';

import styled from 'styled-components';

interface ContainerStyledProps {
  styledProps: {
    hasError: boolean;
  };
}

export const Container = styled.div<ContainerStyledProps>`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  border: ${({ styledProps, theme }) =>
    `1px solid ${styledProps.hasError ? theme.input.errorColor : theme.input.border}`};
`;

export const PrefixSuffix = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  width: 72px;
  color: ${({ theme }) => theme.input.prefixSuffix};
  background-color: ${({ theme }) => theme.input.prefixSuffixBackground};
`;

export const InputContainer = styled.div`
  position: relative;
  flex: 1;

  & p {
    position: absolute;
    z-index: 1;
    background: ${({ theme }) => theme.input.active.prefixSuffix};
    padding: 15px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: ${({ theme }) => theme.input.active.prefixSuffixBackground};
  }

  .invisible {
    display: none;
  }
`;

interface InputProps {
  $darkPlaceholder?: boolean;
  $hasValidIcon?: boolean;
}

export const StyledInput = styled(InputMask)<InputProps>`
  width: 100%;
  height: 48px;
  transition: all 0.3s ease-in-out;
  padding: 12px 15px;
  font-size: 16px;
  border: none;
  color: ${({ theme }) => theme.input.color};
  padding-right: ${({ $hasValidIcon }) => ($hasValidIcon ? '45px' : '15px')};

  &::placeholder,
  ::-webkit-input-placeholder {
    color: ${({ theme, $darkPlaceholder }) => ($darkPlaceholder ? theme.input.prefixSuffix : '')};
  }
  &:-ms-input-placeholder {
    color: ${({ theme, $darkPlaceholder }) => ($darkPlaceholder ? theme.input.prefixSuffix : '')};
  }
`;

export const Error = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.input.errorColor};
`;

export const ValidIcon = styled(MdCheck)`
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto;
  font-size: 20px;
  color: ${({ theme }) => theme.input.valid} !important;
`;
